import { getCO2AequivalentSubscope1 } from '../getCO2Aequivalent';
import { getCO2AequivalentSubscope5 } from '../getCO2Aequivalent';
import { IDs } from '../../../helpers/IDs';
import { isValid as isValidWasser } from '../validData';

export function extractEnergieWasser(data: any, base: any, standort: any) {
    const modul: string = (data || {}).MODUL_SELECTED || null;
    const standorte = data[IDs.ENT_STANDORT];
    const wasser = data[IDs.ENT_ENERGIEDATEN_WASSER].filter((item: any) => !standort || standort.tid === item.standort_tid_orig);

    // Standorte-Map
    const veranstaltungen_enabled = Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION].length > 0 ? data[IDs.ENT_KONFIGURATION][0].veranstaltungen_orig === 1 : false;
    const standorteMap: any = {};
    standorte
        // schließen deaktivierte Veranstaltungen oder Veranstaltungen ohne Standorte aus.
        .filter((s: any) => !((s.standort_typ_tid_orig === 5 || s.standort_typ_tid_orig === 6) && (!veranstaltungen_enabled || !s.standort_tid_orig)))
        .forEach((s: any) => standorteMap[s.tid] = s.energiedaten_erfassen_orig === 1 || s.energiedaten_erfassen === 1);

    /******************** WASSER ****************************************************************** */
    wasser.forEach((item: any) => {
        const standortTid = item.standort_tid_orig ? item.standort_tid_orig : item.standort_tid;
        if (!standortTid || !standorteMap[standortTid]) {
            return;
        }
        if (!isValidWasser(item, IDs.ENT_ENERGIEDATEN_WASSER)) {
            return;
        }
        const jahr = item.jahr;
        if (!base[jahr]) {
            base[jahr] = {};
        }
        const einheit = item.einheit_tid;
        const einheit2 = item.einheit2_tid;
        const einheit_regen = item.einheit_regen_tid;
        const hasVerbrauch2: boolean = modul === 'cfm' && (item.weitere_wasserquellen_orig === 1 || item.weitere_wasserquellen === 1);

        base['flags'].hasWasser = true;
        const abwasser = item.abwasser || (item.abwasser === null ? item.fremdbezug : item.abwasser) || 0;
        const abwasser2 = hasVerbrauch2 ? (item.abwasser2 || (item.abwasser2 === null ? item.verbrauch2 : item.abwasser2) || 0) : 0;
        const kosten_bezug = (item.kosten_bezug || 0);
        const kosten_abwasser = (item.kosten_abwasser || 0) + (hasVerbrauch2 ? (item.kosten_abwasser2 || 0) : 0);
        const kosten_gesamt = kosten_bezug + kosten_abwasser;
        const kosten_rueckerstattung = (item.rueckerstattung || 0);
        const az_von = item.abrechnungszeitraum_von;
        const az_bis = item.abrechnungszeitraum_bis;
        const tage = ((az_bis - az_von) / 86400) + 1;

        let factor_hochrechnung = 1;
        const abrechnungsart = +item.abrechnungsart;
        const az = az_bis - az_von;
        // 1 - Reguläre Abrechnung, 2 - Teilabrechnung, 3 - Erste Abrechnung, 4 - Letzte abrechnung
        // Fall 2 müssen wir nichts machen, da bleibt es beim Faktor 1, da wir nicht hochrechnen.
        if (!abrechnungsart || abrechnungsart === 1 ) {
            const az_jahr = (jahr % 4 === 0 ? 366 : 365) * 86400;
            factor_hochrechnung = az_jahr / (az + 86400);
            // console.log('HR Strom 1 ', jahr, (az_jahr /  86400), (az /  86400), factor_hochrechnung);
        } else if (abrechnungsart === 3) {
            // Wir rechnen von AZ-Von bis zum Jahresende
            const az_ende =   new Date(jahr + 1, 0, 1).getTime() / 1000;
            const az_teil_d = Math.round((az_ende - az_von) / 86400);
            const az_d = Math.round(az / 86400);
            factor_hochrechnung = az_teil_d / (az_d + 1);
            // console.log('HR Strom 3', jahr, az_teil_d, (az_d + 1), factor_hochrechnung, az_bis, az_ende);
        } else if (abrechnungsart === 4) {
            // Wir rechnen vom Jahresbegin bis AZ-Bis
            const az_begin = new Date(jahr, 0, 1).getTime() / 1000;
            const az_teil_d = Math.round((az_bis - az_begin) / 86400) + 1;
            const az_d = Math.round(az / 86400);
            factor_hochrechnung = az_teil_d / (az_d + 1);
            // console.log('HR Strom 4', jahr, az_teil_d, (az_d + 1), factor_hochrechnung, az_bis, az_begin);
        }
        let faktor_einheit = 1;
        let faktor_einheit_regen = 1;
        let faktor_einheit_verbrauch2 = 1;
        if (einheit === 'Liter') {
            faktor_einheit = 1 / 1000;
        }
        if (einheit2 === 'Liter') {
            faktor_einheit_verbrauch2 = 1 / 1000;
        }
        if (einheit_regen) {
            if (einheit_regen === 'Liter') {
                faktor_einheit_regen = 1 / 1000;
            }
        } else {
            faktor_einheit_regen = faktor_einheit;
        }
        base[jahr].abwasser = (base[jahr].abwasser || 0)
            + (abwasser * faktor_einheit * factor_hochrechnung)
            + (abwasser2 * faktor_einheit_verbrauch2 * factor_hochrechnung);
        base[jahr].wassergesamt_kosten = (base[jahr].wassergesamt_kosten || 0) + (kosten_gesamt * factor_hochrechnung);
        base[jahr].wasserbezug_kosten = (base[jahr].wasserbezug_kosten || 0) + (kosten_bezug * factor_hochrechnung);
        base[jahr].abwasser_kosten = (base[jahr].abwasser_kosten || 0) + (kosten_abwasser * factor_hochrechnung);
        base[jahr].rueckerstattung = (base[jahr].rueckerstattung || 0) + kosten_rueckerstattung;

        base[jahr].wasser_verbrauch_jahr = (base[jahr].wasser_verbrauch_jahr || 0)
            + (item.fremdbezug * faktor_einheit * factor_hochrechnung);
        base[jahr].wasser_verbrauch_tag = (base[jahr].wasser_verbrauch_tag || 0)
            + (item.fremdbezug * faktor_einheit * 1000) / tage; // Hier auf Liter rechnen????

        if (modul !== 'cfm' || item.weitere_wasserquellen === null) {
            base[jahr].regen_brunnennutzung = (base[jahr].regen_brunnennutzung || 0)
                + (item.regen_brunnennutzung * faktor_einheit_regen /** factor_hochrechnung */);
        } else if (hasVerbrauch2) {
            base[jahr].regen_brunnennutzung = (base[jahr].regen_brunnennutzung || 0)
                + (item.verbrauch2 * faktor_einheit_verbrauch2 /** factor_hochrechnung */);
        }

        const key_datenqualitaet = 'wasser_datenqualitaet';
        const emissionsfaktorWasser: number = (getCO2AequivalentSubscope1(data, jahr, 'Wasser') || {}).datenqualitaet;
        if (!base[jahr][key_datenqualitaet]) {
            base[jahr][key_datenqualitaet] = [];
        }
        base[jahr][key_datenqualitaet].push({
            wert: +(item.fremdbezug * faktor_einheit * factor_hochrechnung) || 0,
            datenherkunft: +(item.datenherkunft || 0),
            bewertung: 1,
            ...(emissionsfaktorWasser && { emissionsfaktor: emissionsfaktorWasser })
        });

        const key_datenqualitaet_abwasser = 'abwasser_datenqualitaet';
        const emissionsfaktorAbwasser: number = (getCO2AequivalentSubscope5(data, jahr, { kategorie: 'abwasser' }) || {}).datenqualitaet;
        if (!base[jahr][key_datenqualitaet_abwasser]) {
            base[jahr][key_datenqualitaet_abwasser] = [];
        }
        base[jahr][key_datenqualitaet_abwasser].push({
            wert: +((abwasser * faktor_einheit * factor_hochrechnung) + (abwasser2 * faktor_einheit_verbrauch2 * factor_hochrechnung)) || 0,
            datenherkunft: +(item.datenherkunft || 0),
            bewertung: 1,
            ...(emissionsfaktorAbwasser && { emissionsfaktor: emissionsfaktorAbwasser })
        });
        // console.log('Wasser', tage, item, base[jahr][key_datenqualitaet]);
    });
}
